<template>
  <el-dialog
    title="Incident"
    width="600px"
    :visible.sync="isShowing"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
  >
    <el-form
      ref="incidentForm"
      :model="incident"
      label-width="120px"
      class="incident-form"
    >
      <el-form-item label="Incident Name">
        <el-input
          v-model="incident.name"
        />
      </el-form-item>
      <el-form-item label="Type">
        <el-select
          v-model="incident.type"
          :placeholder="'Select Incident Type'"
          class="w-100"
          value-key="id"
        >
          <el-option
            v-for="type in types"
            :key="type.id"
            :label="type.name"
            :value="type"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Priority">
        <el-select
          v-model="incident.priority"
          :placeholder="'Select Incident Priority'"
          class="w-100"
          value-key="id"
        >
          <el-option
            v-for="priority in priorities"
            :key="priority.id"
            :label="priority.name"
            :value="priority"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Status">
        <el-select
          v-model="incident.status"
          :placeholder="'Select Incident Status'"
          class="w-100"
          value-key="id"
        >
          <el-option
            v-for="status in statuses"
            :key="status.id"
            :label="status.name"
            :value="status"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Description">
        <el-input
          v-model="incident.description"
          type="textarea"
          :rows="4"
          placeholder="Description of the incident"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button
        @click="isShowing = false"
      >
        Close
      </el-button>
      <el-button
        v-loading="isSaving"
        type="primary"
        @click="incident.id ? save() : create()"
      >
        Save
      </el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'IncidentDialog',
  props: {
    incident: {
      type: Object,
      default: () => ({
        type: {},
        priority: {},
        status: {},
        description: '',
        id: null,
        name: ''
      })
    }
  },
  data () {
    return {
      isShowing: false,
      types: [],
      priorities: [],
      statuses: [],
      isSaving: false
    }
  },
  mounted () {
    this.loadTypes()
    this.loadPriorities()
    this.loadStatuses()
  },
  methods: {
    showDialog () {
      this.isShowing = true
    },
    loadTypes () {
      this.$sdk.incident_type.list()
        .then(types => {
          this.types = types
        })
        .catch(error => {
          console.error('Error loading incident types:', error)
        })
    },
    loadPriorities () {
      this.$sdk.incident_priority.list()
        .then(priorities => {
          this.priorities = priorities
        })
        .catch(error => {
          console.error('Error loading incident priorities:', error)
        })
    },
    loadStatuses () {
      this.$sdk.incident_status.list()
        .then(statuses => {
          this.statuses = statuses
        })
        .catch(error => {
          console.error('Error loading incident statuses:', error)
        })
    },
    create () {
      this.isSaving = true
      this.$sdk.incident.create(this.incident)
        .then(() => {
          this.isSaving = false
          this.$emit('save')
          this.isShowing = false
        })
        .catch(error => {
          this.isSaving = false
          console.error('Error creating incident:', error)
        })
    },
    save () {
      this.isSaving = true
      this.incident.save()
        .then(() => {
          this.isSaving = false
          this.$emit('save')
          this.isShowing = false
        })
        .catch(error => {
          this.isSaving = false
          console.error('Error saving incident:', error)
        })
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 22px;
}
</style>
